import fetchManager from '@utils/fetchManager'
import { urlQueryData, getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");
// const API_URL = 'http://localhost:8083'

export default {
  getProfiles: async (querys) => {
    const errorModal = { show: 'no' }
    const url = urlQueryData(`${API_URL}/CatalogueManagement/api/amx/cpe/profiles`, querys)

    const response = await fetchManager(url, {}, errorModal)
    return response
  },
  updateVisibilityProfile: async (id, data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/profiles/status/${id}`, {
        method: 'PATCH',
        data,
      })
    return response
  },

  deleteProfle: async (id, data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/profiles/${id}`, {
        method: 'DELETE',
        data,
      })
    return response
  },
  getPermissionsCatalog: async () => {
    const errorModal = { show: 'no' }
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/profiles/permissions`, {}, errorModal)
    return response
  },
  newProfile: async (data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/profiles`, {
        method: 'POST',
        data,
      })
    return response
  },
  editProfile: async (data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/profiles`, {
        method: 'PUT',
        data,
      })
    return response
  },
}